<template>
    <ui-Airboard
        :panel="$session.isVerified() ? 'dashboard' : 'dashboard--notVerified'"
        :openTab="openTab"
        :idView="`componet_${_uid}`"
        :loading="loading"
    >
        <template v-slot:menuBar v-if="$session.isVerified()">
            <RefreshIco></RefreshIco>
            <ConfigPanelMixinMenu></ConfigPanelMixinMenu>
        </template>
        <template v-slot:head v-if="$session.isVerified()">
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <div class="welcome">{{ $dicc.dashboard.welcome }}</div>
        </template>
        <template v-slot:body v-if="$session.isVerified()">
            <Location
                v-for="location in locations"
                :key="location.id"
                :location="location"
                @click="goLocation(location)"
                @addInstallation="addInstallation(location)"
            ></Location>
        </template>
        <template v-slot:body v-else>
            <inline-svg class="logo" :src="getImage('mysair-logo.svg')"></inline-svg>
            <div class="mailValidation">{{ $dicc.dashboard.needValidate }}</div>
            <a class="btn btn--outline" @click="reSendMail">{{ $dicc.dashboard.reSendMail }}</a>
            <hr />
            <a class="link mt-2" @click.stop.prevent="Logout" href>{{ $dicc.dashboard.loginAction }}</a>
        </template>
        <template v-slot:tab v-if="$session.isVerified()">
            <Favorites :show.sync="openTab" @deviceClick="openDevicePanel($event)"></Favorites>
        </template>
        <template v-slot:panels>
            <DevicePanelMixinPanel @updateDevice="init()"></DevicePanelMixinPanel>
            <ConfigPanelMixinPanels @updateLocation="init()"> </ConfigPanelMixinPanels>
            <AddInstallationPanel
                :show.sync="showAddInstallationPanel"
                :location="locationAddInstallation"
                @addedInstallation="init()"
            ></AddInstallationPanel>
        </template>
    </ui-Airboard>
</template>

<script>
    import Favorites from '../components/Favorites';
    import Location from '../components/Location';
    import Device from '../components/Device';
    import AddInstallationPanel from '../view_panels/AddInstallationPanel';
    import { ViewMixin } from '../mixins/ViewMixin';
    import { DevicePanelMixin } from '../mixins/DevicePanelMixin';
    import { ConfigPanelMixin } from '../mixins/ConfigPanelMixin';
    import { mapState } from 'vuex';

    export default {
        name: 'Dashboard',
        components: { Location, Favorites, Device, AddInstallationPanel },
        mixins: [ViewMixin, ConfigPanelMixin, DevicePanelMixin],
        provide() {
            return { view: this };
        },
        data() {
            return {
                testActive: false,
                openTab: false,
                intervalCheck: 0,
                showAddInstallationPanel: false,
                locationAddInstallation: {},
            };
        },
        mounted() {
            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });
            this.init();
        },
        methods: {
            init(callbackStart, callbackEND) {
                if (this.$session.isVerified()) this.initVerified(callbackStart, callbackEND);
                else this.initNoVerified();
            },
            initVerified(callbackStart, callbackEND) {
                this.getSpaces(callbackStart, callbackEND);
                this.getLocations(callbackStart, callbackEND);
            },
            initNoVerified() {
                this.$uniqueSetTimeout('initNoVerified', () => this.checkUser(), this.intervalCheck);
                this.intervalCheck = 10000;
            },
            getSpaces(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getSpaces(
                    null,
                    null,
                    (data) => {
                        this.$store.commit('clearSpaces');
                        data.entity.forEach((x) => {
                            this.$store.commit('addSpace', {
                                [x.id]: x,
                            });
                        });
                    },
                    null,
                    callbackEND
                );
            },
            getLocations(callbackStart, callbackEND) {
                if (callbackStart) callbackStart();
                this.$api.getLocations(
                    (data) => {
                        this.$store.commit('clearLocations');
                        data.entity.forEach((x) => {
                            this.$store.commit('addLocation', {
                                [x.id]: x,
                            });
                        });
                    },
                    null,
                    callbackEND
                );
            },
            goLocation(location) {
                this.$router.push({
                    name: 'Location',
                    params: { id: location.id, location: location },
                });
            },
            addInstallation(location) {
                this.locationAddInstallation = location;
                this.showAddInstallationPanel = true;
            },
            checkUser() {
                this.$api.getUser(
                    (data) => this.$session.setUpdateUser(data.entity),
                    null,
                    () => this.init()
                );
            },
            reSendMail() {
                this.loading++;

                this.$api.userVerify(
                    {
                        redirect_uri: this.$router.getFullRoute({ name: 'Verify' }),
                    },
                    (response) =>
                        this.$toast({
                            message: this.$dicc.dashboard.reSendMailSucces,
                            container: `#componet_${this._uid}`,
                            type: 'is-success',
                        }),
                    (error) =>
                        this.$toast({
                            message: this.$dicc.errors[error.data.error],
                            container: `#componet_${this._uid}`,
                            type: 'is-danger',
                        }),
                    () => this.loading--
                );
            },
            Logout() {
                this.$session.logout();
                this.$router.push({ name: 'Login' });
            },
        },
        computed: {
            reference() {
                return this.data.reference;
            },
            installation_ref() {
                return this.data.installation_ref;
            },
            data() {
                return this.device || {};
            },
            ...mapState({
                spaces(state) {
                    return Object.values(state.spaces) || [];
                },
                locations(state) {
                    return Object.values(state.locations) || [];
                },
            }),
        },
    };
</script>
